<template>
  <div class="bg-primary tab-header">
    <b-container fluid>
      <b-row slot="header" class="p-3 d-flex align-items-center flex-container">
        <b-col md="6">
          <h5 class="bg-primary p-3 my-auto"> {{ title }} </h5>
        </b-col>

        <b-col md="6">
          <b-row style="display: flex;justify-content: flex-end;">
            <b-col md="6" class="col" style="z-index: 100;">
              <b-input-group>
                <b-form-input class="search-text" @input="emitInput" :placeholder="$t('WORKFLOW.SEARCH')" ref="searchInput"/>
                <div v-show="showClear" class="clear-btn" @click="clearFilter" v-html="svg.broom"></div>
              </b-input-group>
            </b-col>
            <b-col md="6" class="col" style="z-index: 100;">
              <multiselect 
                class="custom-multiselect" 
                :options="editedOptions"
                track-by="title"
                label="title"
                :value="editedByValue"
                :close-on-select="true"
                :custom-label="customLabel"
                :show-labels="false"
                :preselect-first="true"
                placeholder="Edited By"
                @remove="optionRemoved($event)"
                @select="optionAdded($event)"
                :multiple="true">
                  <template
                    slot="option"
                    slot-scope="props"
                  >
                    <div class="option__desc">
                      <div class="avatar">{{props.option.title[0]}}</div>
                      <input
                        type="checkbox"
                        :checked="isSelected(props.option.title)"
                      />
                      <span class="option__title">{{ props.option.title }}</span>
                    </div>
                  </template>
              </multiselect>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import svg from '../../_svg.js'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  data () {
    return {
      svg: svg,
      showClear: false,
      selectedEditedBy: []
    }
  },
  props: {
    title: String,
    editedByValue: Array,
    editedOptions: Array
  },
  methods: {
    emitInput (input) {
      this.$emit('filterInput', input)
      if (input !== '') this.showClear = true
      else this.showClear = false
    },
    optionAdded (input) {
      this.selectedEditedBy = [...this.editedByValue, input]
      this.$emit('update:editByValue', this.selectedEditedBy)
    },
    optionRemoved (input) {
      this.selectedEditedBy = this.selectedEditedBy.filter((value) => value.title !== input.title)
      this.$emit('update:editByValue', this.selectedEditedBy)
    },
    clearFilter () {
      this.$refs.searchInput.$el.value = ''
      this.emitInput('')
      this.showClear = false
    },
    customLabel ({ title }) {
      return `${title}`
    },
    isSelected (currentTitle) {
      for (const element of this.editedByValue) {
        if (element.title === currentTitle) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.search-text {
  border-radius: 20px;
}

.flex-container {
  display: flex;
  justify-content: space-between;
}
.tab-header h5{
  text-transform: uppercase;
}

  .tab-header{
    // display: flex;
    // justify-content: space-between;
  }


.multiselect{
    width: 300px;
}
.avatar{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #f9cb9a;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #262e38;
    margin: 8px;
}
.option__desc{
    display: flex;
    align-items: center;
    gap: 5px;
}
li .multiselect__element{
    align-items: center;
    height: 40px !important;
}
.multiselect__tag{
    background: #0e2547 !important;
}
.multiselect__tag:after{
        color: #ddd !important;
}
.multiselect__option{
    padding: 0px !important;
}
.multiselect__content{
    display: flex;
    flex-direction: column;
}
.multiselect__tag-icon:focus, .multiselect__tag-icon:hover{
  background: #0e2547 !important;
}
.typo__label{
  font-family: 'Lato' !important;
  font-weight: 600;
  font-size: 14px;
}
.multiselect__tags {
 padding-top: 0px !important;
}
.multiselect__input{
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/FeaturesSearchBar.vue